import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { t } from "i18next";
import { ApiError, ApiServiceError } from "libs/api";
import toast from "react-hot-toast";

import { AiReviewItem } from "../../aiReview.types";
import { AI_REVIEW_QUERY_KEY } from "../../constants/enums";
import { reviewStatusToastKey } from "../../helpers/review";
import {
  UpdateReviewItemBody,
  requestUpdateReviewItem
} from "./updateReviewItem.request";

// The page reads it (useIsMutating) to disable the buttons of the row whose
// call is running, even when another row is changed meanwhile.
export const AI_REVIEW_UPDATE_MUTATION_KEY = [AI_REVIEW_QUERY_KEY, "update"];

// Errors are toasted once, here (the global bad-request and not-found
// handlers are off). On success the whole prefix is refetched: the item
// changes tab, and the counts and the sidebar badge follow. The mutation
// stays loading until that refetch is done, so the row cannot be clicked
// twice before it moves.
const useUpdateReviewItem = () => {
  const queryClient = useQueryClient();
  return useMutation<
    AiReviewItem,
    ApiServiceError<ApiError>,
    UpdateReviewItemBody
  >({
    mutationKey: AI_REVIEW_UPDATE_MUTATION_KEY,
    mutationFn: async (body) => await requestUpdateReviewItem(body),
    meta: { preventDefaultBadRequest: true, preventDefaultNotFound: true },
    onError: toastServerError,
    onSuccess: async (_item, { status }) => {
      toast.success(t(reviewStatusToastKey(status)));
      await queryClient.invalidateQueries({ queryKey: [AI_REVIEW_QUERY_KEY] });
    }
  });
};

export default useUpdateReviewItem;
